import React from 'react'


export default function Service(props) {
    return (
        <div className="service">
            <div className="service-icon">
                <div>
                    <div>
                        {props.icon}
                    </div>
                </div>
            </div>
            <h2>{props.heading}</h2>
            <p>{props.content}</p>
        </div>
    )
}
